// PageReportView Component

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import PageHeaderReportView from '../../layout/page_header_reportview/page_header_reportview.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import ReportPriceCell from '../../report/report_pricecell/report_pricecell.jsx'
import ReportInfoCell from '../../report/report_infocell/report_infocell.jsx'
import List from '../../../../components/List/List.jsx'
import DataTable from '../../../../components/DataTable/DataTable.jsx'
import DialogReportExport from '../../dialog/dialog_report_export/dialog_report_export.jsx'
import ReportProjectTitleCell from '../../../common/common/report_project_titlecell/report_project_titlecell.jsx'
import ReportProjectProgressCell from '../../../common/common/report_project_progresscell/report_project_progresscell.jsx'
import ReportProjectManagerCell from '../../report/report_project_manager_cell/report_project_manager_cell.jsx'
import ReportTimeDescCell from '../../../common/common/report_time_desccell/report_time_desccell.jsx'
import PlannerContent from '../../planner/planner_content/planner_content.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import currency from '../../../lib/currency.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import getCurrentDateFilters from './getCurrentDateFilters.js'
import { setFilterData } from './setFilterData.js'
import { REPORTS } from '../../../../shared/constants.js'
import Acl from '../../../lib/acl.jsx'
import { ReportsIcon } from '../../../common/layout/menu_icons/reports.jsx'

class PageReportView extends PageBase {
  constructor (props) {
    super(props, 'reportview', 'report', `report-${props.reportIdent}`)

    this.state = {
      isLoading: true,
      dataDate: null
    }

    this.data = {
      reportInfo: null,
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      sort: 'title',
      sortAsc: true,
      pageNo: 1,
      pageState: {
        sort: 'title',
        sortAsc: true,
        filter: null
      },
      oldPlannerData: null,
      bShowForm: false
    }

    this._bUnMounted = false
    this._isProcessFilterObject = false
    this._references = {
      reportExportDialog: React.createRef(),
      reportHeader: React.createRef()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._isProcessFilterObject = !!this.props.filterObj
    this._getData()
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
    this._bUnMounted = true
  }

  renderContent () {
    return (
      <div className={`page-reportview report-${this.props.reportIdent}`}>
        {this._renderMessage()}
        {this._renderList()}
      </div>
    )
  }

  renderHeader () {
    if (this.props.reportIdent === REPORTS.WORK_IN_PROGRESS) {
      return this._renderHeaderWorkInProgress()
    } else if (this.props.reportIdent === REPORTS.TIME_REGISTRATION) {
      return this._renderHeaderTimeRegistration()
    }

    const titleMsg =
      this.data.reportInfo && this.data.reportInfo.report
        ? this.data.reportInfo.report.ident
        : ''
    const msgIdent = titleMsg.replace(/-/g, '').toLowerCase()
    const titleIdent = `report.item.title${msgIdent}`
    const title = titleIdent
      ? `${IntlUtil.convertMessage(
          'report.list.labelReport'
        )} ${IntlUtil.convertMessage(titleIdent)}`
      : ''

    if (this.data.reportInfo) {
      return (
        <PageHeaderReportView
          title={title}
          reportType={this.props.reportIdent}
          filter={this.data.pageState.filter}
          reportInfo={this.data.reportInfo}
          onChangeFilter={this._onChangeFilter.bind(this)}
          onSearchContact={this._onSearchContact.bind(this)}
          onSearchTag={this._onSearchTag.bind(this)}
          onSearchProject={this._onSearchProject.bind(this)}
          onSearchUser={this._onSearchUser.bind(this)}
          onExport={this._onExport.bind(this)}
          showExport={!(this.data.reportInfo.items.length <= 0)}
          isPlannerAllowed={Acl.isPlannerAllowed()}
        />
      )
    }

    return ''
  }

  getContentClassname () {
    return this.props.reportIdent === REPORTS.PLANNER_OVERVIEW ? 'full' : ''
  }

  /* Event Handlers */
  _onChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1
    this.data.oldPlannerData = this.data.reportInfo
      ? this.data.reportInfo.items
      : null
    this._reloadData()
  }

  _handleDocumentKeyDown = evt => {
    if (this.data.bShowForm || this.ignoreAutoSearch) return

    if (this._references.reportHeader.current) {
      const keyCode = evt.keyCode || 0

      if (keyCode === 27) {
        this._references.reportHeader.current.onEscKeyDown()
      }
    }
  }

  _onSearchContact (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          company: { $regex: pattern, $options: 'i' },
          $select: ['_id', 'company'],
          $limit: 15,
          archived: false
        }
      }

      app
        .service('/api/contact')
        .find(params)
        .then(result => {
          if (result.data) {
            callback(
              result.data.map(obj => ({
                label: obj.company,
                value: obj.id
              }))
            )
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug('Page Report view: _onSearchContact err', err)
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onSearchTag (keyword, callback) {
    this._onCommonFilterTagSearch(keyword, [], callback)
  }

  _onSearchProject (keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback)
  }

  _onSearchUser (keyword, callback) {
    this._onCommonFilterUserSearch(keyword, callback)
  }

  _onClickExport (fileType, e) {
    e.preventDefault()

    const params = {
      query: {
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        $client: { ident: this.props.reportIdent, filterData: {} }
      }
    }

    const filter = this.data.pageState.filter
    this._processFilter(filter, params)

    const data = {
      viewIdent: this.props.reportIdent,
      fileType: fileType
    }
    // @TODO: this timeout is temporarily  set to 30s as a workaround for exporting large reports (aka: one year) please remove this once the performance issues are fixed
    // @TODO (UPDATE): After two years, the problem still happens and the timeout got to 30s to 60s. It's happening again, but since we currently have a new project, priority on solving this performace issue is not in the list. It was agreed to increase it to 920s.
    app.service('/api/report/export').timeout = 3600000 * 3
    app
      .service('/api/report/export')
      .create(data, params)
      .then(result => {
        app.redirect(
          `/export/${app.getTeamId()}/report-${this.props.reportIdent}/${
            result.fileType
          }/${result.fileName}`
        )
        if (this._references.reportExportDialog.current) {
          this._references.reportExportDialog.current.toggleLoading()
        }
      })
      .catch(err => {
        if (this._references.reportExportDialog.current) {
          this._references.reportExportDialog.current.toggleLoading()
          this._references.reportExportDialog.current.showError()
        }
        app.debug('PageReportView: onClickExport error', err)
      })
  }

  _onExport (_ev) {
    if (this._references.reportExportDialog.current) {
      this._references.reportExportDialog.current.show()
    }
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'title',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        filter: pageState.filter || null
      }
    }
  }

  /* Private functions */
  _reloadData () {
    this._updatePageState(this.data.pageState)
    this._getData()
  }

  _renderExportDialog (_ident, _ev) {
    let title = 'report.list.titleWorkInProgress'
    if (this.props.reportIdent === REPORTS.CLOSED_PROJECTS_V2) {
      title = 'report.list.titleClosedProjects'
    } else if (this.props.reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY) {
      title = 'report.list.titleEmployeeProductivity'
    } else if (this.props.reportIdent === REPORTS.TIME_REGISTRATION) {
      title = 'report.list.titleTimeRegistration'
    } else if (this.props.reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY_V2) {
      title = 'report.list.titleEmployeeProductivity'
    } else if (this.props.reportIdent === REPORTS.PLANNER_OVERVIEW) {
      title = 'report.list.titlePlannerOverview'
    }

    return (
      <DialogReportExport
        ref={this._references.reportExportDialog}
        title={title}
        onExportExcel={this._onClickExport.bind(this, 'xlsx')}
        onExportCsv={this._onClickExport.bind(this, 'csv')}
      />
    )
  }

  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._processFilterObjects(done)
        },
        done => {
          this._getDataReport(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _processFilterObjects (callback) {
    if (this.props.filterObj && this._isProcessFilterObject) {
      const pageState = this.data.pageState
      const filterObj = this.props.filterObj
      pageState.filter = {
        timeRegistration: {
          contact: filterObj.contact,
          project: filterObj.project,
          user: filterObj.user,
          dateFilter: filterObj.dateFilter,
          keywordContact: filterObj.contactName,
          keywordProject: filterObj.projectName,
          keywordUser: filterObj.memberName
        }
      }

      this._isProcessFilterObject = false
      callback(null)
    } else {
      callback(null)
    }
  }

  _getDataReport (callback) {
    const params = {
      query: {
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        $client: { ident: this.props.reportIdent, filterData: {} }
      }
    }

    if (this.data.pageState.sort) {
      params.query.$sort = {
        [this.data.pageState.sort]: this.data.pageState.sortAsc ? 1 : -1
      }
    }

    // Process Filters
    let filter = this.data.pageState.filter
    if (this.props.reportIdent === REPORTS.PLANNER_OVERVIEW) {
      filter = filter || {}
      filter.plannerOverview = this._getPlannerFilter(
        filter.plannerOverview || null
      )
    } else if (this.props.reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY_V2) {
      filter = filter || {}
      filter.employeeProductivityV2 = this._getEmpProductivityFilter(
        filter.employeeProductivityV2 || null
      )
    }

    this.data.pageState.filter = filter

    this._processFilter(filter, params)

    app.service('/api/report/view').timeout = 3600 * 1000 * 3
    app
      .service('/api/report/view')
      .get(null, params)
      .then(result => {
        this._processSorting(result)
        callback(null)
      })
      .catch(err => {
        app.debug('PageReportView: getDataReport err', err)
        callback(err)
      })
  }

  _processSorting (reportRes) {
    if (reportRes && reportRes.items && this.data.pageState.sort) {
      reportRes.items = _.sortBy(reportRes.items, this.data.pageState.sort)
      if (!this.data.pageState.sortAsc) {
        reportRes.items.reverse()
      }
    }

    this.data.reportInfo = reportRes
  }

  _processFilter (filterRes, params) {
    if (!filterRes) {
      this._processFilterDate(params, this._getDefaultDateFilter())
      return
    }

    const reportIdent = this.props.reportIdent
    let filter = filterRes.workInProgress
    if (reportIdent === REPORTS.CLOSED_PROJECTS) {
      filter = filterRes.closedProjects
    } else if (reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY) {
      filter = filterRes.employeeProductivity
    } else if (reportIdent === REPORTS.TIME_REGISTRATION) {
      filter = filterRes.timeRegistration
    } else if (reportIdent === REPORTS.CLOSED_PROJECTS_V2) {
      filter = filterRes.closedProjectsV2
    } else if (reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY_V2) {
      filter = filterRes.employeeProductivityV2
      params.query.$client.filterData = {
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        filterType: filter.filterType,
        startWeekNo: filter.startWeekNo,
        startMonth: filter.startMonth,
        graphFromDate: filter.graphFromDate,
        graphToDate: filter.graphToDate
      }

      if (filter.users && filter.users.length > 0) {
        params.query.$client.filterData.userIds = filter.users.map(
          user => user.value
        )
      }
      const dateFilter =
        filter && filter.dateFilter
          ? filter.dateFilter
          : this._getDefaultDateFilter()
      if (dateFilter) {
        if (dateFilter.value.from) {
          filter.fromDate = new Date(dateFilter.value.from)
          params.query.$client.filterData.fromDate = dateFilter.value.from
        }

        if (dateFilter.value.to) {
          filter.toDate = new Date(dateFilter.value.to)
          params.query.$client.filterData.toDate = new Date(dateFilter.value.to)
          params.query.$client.filterData.toDate.setHours(23, 59, 59, 0)
        }
      }
    } else if (reportIdent === REPORTS.PLANNER_OVERVIEW) {
      const plannerFilter = filterRes.plannerOverview
      params.query.$client.filterData = {
        fromDate: plannerFilter.fromDate,
        toDate: plannerFilter.toDate,
        filterType: plannerFilter.filterType,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
      }

      if (plannerFilter.contact) {
        params.query.$client.filterData.contactIds = [
          plannerFilter.contact.value
        ]
      }

      if (plannerFilter.users && plannerFilter.users.length > 0) {
        params.query.$client.filterData.userIds = plannerFilter.users.map(
          user => user.value
        )
      }

      if (plannerFilter.tags && plannerFilter.tags.length > 0) {
        params.query.$client.filterData.tags = plannerFilter.tags.map(
          obj => obj.value
        )
      }
    }

    if (filter) {
      if (filter.tags && filter.tags.length > 0) {
        params.query.$client.filterData.tags = filter.tags
      }

      if (filter.contact) {
        params.query.$client.filterData.contactId = filter.contact.value
      }

      if (filter.project) {
        params.query.$client.filterData.projectId = filter.project.value
      }

      if (filter.user) {
        params.query.$client.filterData.userId = filter.user.value
      }
    }
    const dateFilter =
      filter && filter.dateFilter
        ? getCurrentDateFilters(filter.dateFilter)
        : this._getDefaultDateFilter()
    this._processFilterDate(params, dateFilter)
  }

  _processFilterDate (params, dateFilter) {
    if (dateFilter && dateFilter.value) {
      const reportIdent = this.props.reportIdent
      const filterData = params.query.$client.filterData
      params.query.$client.filterData = setFilterData(reportIdent, filterData, dateFilter.value)
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageReportView: _onDataReceived Error', err)
    } else {
      app.debug('PageReportView: _onDataReceived [done]')
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _renderMessage () {
    if (!this.state.isLoading && !this.data?.reportInfo?.items?.length) {
      const reportIdent = this.props.reportIdent

      let infoText = 'report.view.msgNothingSelectedInfo'
      if (reportIdent === REPORTS.WORK_IN_PROGRESS) {
        infoText = 'report.view.msgWorkInProgressNothingSelectedInfo'
      } else if (
        reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY ||
        reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY_V2
      ) {
        infoText = 'report.view.msgEmpProductivityNothingSelectedInfo'
      } else if (reportIdent === REPORTS.TIME_REGISTRATION) {
        infoText = 'report.view.msgTimeRegNothingSelectedInfo'
      } else if (reportIdent === REPORTS.PLANNER_OVERVIEW) {
        infoText = 'report.view.msgPlannerOverviewNothingSelectedInfo'
      }

      return (
        <ContentMessage
          message='report.view.msgNothingSelected'
          info={infoText}
        />
      )
    }

    return null
  }

  _renderList () {
    if (this.state.isLoading) {
      return null
    }

    if (this.props.reportIdent === REPORTS.WORK_IN_PROGRESS) {
      return this._renderWorkInProgressList()
    } else if (this.props.reportIdent === REPORTS.CLOSED_PROJECTS) {
      return this._renderClosedProjectList()
    } else if (this.props.reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY) {
      return this._renderEmployeeProductivityList()
    } else if (this.props.reportIdent === REPORTS.TIME_REGISTRATION) {
      return this._renderTimeRegistrationList()
    } else if (this.props.reportIdent === REPORTS.CLOSED_PROJECTS_V2) {
      return this._renderClosedProjectListV2()
    } else if (this.props.reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY_V2) {
      return this._renderEmployeeProductivityListV2()
    } else if (this.props.reportIdent === REPORTS.PLANNER_OVERVIEW) {
      return this._renderPlannerOverview()
    }

    return ''
  }

  _renderWorkInProgressList () {
    if (this.data.reportInfo.items.length <= 0) {
      return null
    }

    const projectSetting = app.projectSetting
    const projectList = this.data.reportInfo.items

    const sortOptions = [
      { label: 'Title', value: 'title' },
      { label: 'Progress', value: 'percentageCompleted' },
      { label: 'BudgetedHours', value: 'budgetHours' },
      { label: 'ClockedHours', value: 'trackedHoursValue' },
      { label: 'BudgetedCosts', value: 'budgetExpenses' },
      { label: 'BookCosts', value: 'expenseTracked' },
      { label: 'BudgetedSellingPrice', value: 'sellingBudget' },
      { label: 'ActuallyInvoiced', value: 'invoicedHours' }
    ]

    if (projectSetting.isPmVisible) {
      sortOptions.push({
        label: 'ProjectManager',
        value: 'projectManagerName'
      })
    }

    const columns = [
      {
        label: 'report.view.projectName',
        identifier: 'title',
        width: projectSetting.isPmVisible ? '11%' : '14%',
        sort: true,
        type: 'custom',
        customType: 'textWithInfo',
        info2Identifier: 'company',
        info3Identifier: projectSetting.useProjectNo ? 'projectNumber' : '',
        field: 'contact'
      },
      {
        label: 'report.view.progress',
        identifier: 'percentageCompleted',
        width: projectSetting.isPmVisible ? '9%' : '11%',
        sort: true,
        type: 'progress'
      },
      {
        label: 'report.view.budgetHours',
        identifier: 'timeBudget',
        width: projectSetting.isPmVisible ? '10%' : '12%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.trackedHoursValue',
        identifier: 'trackedHours',
        width: projectSetting.isPmVisible ? '11%' : '13%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.budgetExpenses',
        identifier: 'budgetExpenses',
        width: projectSetting.isPmVisible ? '11%' : '14%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.budgetedExpenseTracked',
        identifier: 'expenseTracked',
        width: projectSetting.isPmVisible ? '11%' : '12%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.sellingBudget',
        identifier: 'sellingBudget',
        width: projectSetting.isPmVisible ? '10%' : '12%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.invoicedHours',
        identifier: 'invoicedHours',
        width: projectSetting.isPmVisible ? '12%' : '12%',
        sort: true,
        type: 'custom',
        customType: 'price'
      }
    ]

    if (projectSetting.isPmVisible) {
      columns.push({
        label: 'report.view.projectManager',
        identifier: 'projectManagerName',
        width: '15%',
        sort: true,
        type: 'custom',
        customType: 'projectManager'
      })
    }

    return (
      <div className='listwrap'>
        <List
          objectList={projectList}
          columns={columns}
          renderCustomCell={this._onRenderCustom.bind(this)}
          sortOptions={sortOptions}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
        {this._renderExportDialog(this, this.props.reportIdent)}
      </div>
    )
  }

  _renderClosedProjectList () {
    if (this.data.reportInfo.items.length <= 0) {
      return null
    }

    const projectSetting = app.projectSetting
    const projectList = this.data.reportInfo.items
    const sortOptions = [
      { label: 'Name', value: 'title' },
      { label: 'Hours Tracked', value: 'hoursTracked' },
      { label: 'Expense Tracked', value: 'expenseTracked' },
      { label: 'Invoiced', value: 'invoiced' },
      { label: 'Margin', value: 'margin' }
    ]
    const columns = [
      {
        label: 'report.view.name',
        identifier: 'title',
        width: '30%',
        sort: true,
        type: 'custom',
        customType: 'textWithInfo',
        info2Identifier: 'company',
        info3Identifier: projectSetting.useProjectNo ? 'projectNumber' : '',
        field: 'contact'
      },
      {
        label: 'report.view.hoursTracked',
        identifier: 'trackedHours',
        width: '20%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.expenseTracked',
        identifier: 'expenseTracked',
        width: '20%',
        sort: true,
        type: 'custom',
        customType: 'price',
        formatOverdue: true,
        baseTotalField: 'budgetHours',
        getTooltipInfo: report => {
          return {
            ident: 'report.view.expenseTooltipBudget',
            data: {
              budget: currency.formatSymbol(report.budgetHours),
              percentage: `${(
                (report.expenseTracked / report.budgetHours) *
                100
              ).toFixed(2)}%`
            }
          }
        }
      },
      {
        label: 'report.view.invoiced',
        identifier: 'invoicedHours',
        width: '15%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'report.view.margin',
        identifier: 'margin',
        width: '15%',
        sort: true,
        type: 'custom',
        customType: 'price',
        baseTotalField: 'estimatedMargin',
        formatMargin: true,
        getTooltipInfo: report => {
          return {
            ident: 'report.view.expenseTooltipEstimatedMargin',
            data: {
              estimatedMargin: currency.formatSymbol(report.estimatedMargin)
            }
          }
        }
      }
    ]

    return (
      <div className='listwrap'>
        <List
          objectList={projectList}
          columns={columns}
          renderCustomCell={this._onRenderCustom.bind(this)}
          sortOptions={sortOptions}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
        {this._renderExportDialog(this, this.props.reportIdent)}
      </div>
    )
  }

  _renderClosedProjectListV2 () {
    if (!this.data?.reportInfo?.items?.length) {
      return null
    }

    const projectList = this.data.reportInfo.items
    const sortOptions = [
      { label: 'Name', value: 'title' },
      { label: 'Hours Tracked', value: 'hoursTracked' },
      { label: 'Expense Tracked', value: 'expenseTracked' },
      { label: 'Invoiced', value: 'invoiced' },
      { label: 'Margin', value: 'margin' }
    ]
    const columns = [
      {
        label: 'report.view.name',
        identifier: 'title',
        width: '39%',
        sort: true,
        type: 'custom',
        customType: 'projectwithinfo',
        title: 'project',
        subTitle: 'contact',
        values: [
          { label: 'Budget', value: 'budgetHours' },
          { label: 'Invoiced', value: 'invoicedHours' },
          { label: 'Planned', value: 'plannedHours' },
          { label: 'Tracked', value: 'trackedHours' }
        ]
      },
      {
        label: 'report.view.margin',
        identifier: 'margin',
        width: '30%',
        sort: true,
        type: 'custom',
        customType: 'progresswithinfo',
        value: 'margin',
        totalValue: 'invoicedHours',
        status: 'margin'
      },
      {
        label: 'report.view.trackedBudgeted',
        identifier: 'trackedBudgeted',
        width: '30%',
        sort: true,
        type: 'custom',
        customType: 'progresswithinfo',
        value: 'trackedHours',
        totalValue: 'budgetHours',
        status: 'budget'
      }
    ]

    return (
      <div className='listwrap'>
        <List
          objectList={projectList}
          columns={columns}
          renderCustomCell={this._onRenderCustom.bind(this)}
          sortOptions={sortOptions}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
        {this._renderExportDialog(this, this.props.reportIdent)}
      </div>
    )
  }

  _renderEmployeeProductivityList () {
    if (this.data.reportInfo.items.length <= 0) {
      return null
    }
    const projectList = this.data.reportInfo.items
    const sortOptions = [
      { label: 'Name', value: 'firstName' },
      { label: 'Available Tracked', value: 'availableHours' },
      { label: 'Hours Tracked', value: 'hoursTracked' },
      { label: 'Productive Hours', value: 'productiveHours' },
      { label: 'Productivity', value: 'productivity' }
    ]
    const columns = [
      {
        label: 'report.view.name',
        identifier: 'name',
        width: '20%',
        sort: true,
        type: 'text'
      },
      {
        label: 'report.view.availableHours',
        identifier: 'grossHours',
        width: '15%',
        sort: true,
        type: 'minutestotime'
      },
      {
        label: 'report.view.hoursTracked',
        identifier: 'productivityHours',
        width: '15%',
        sort: true,
        type: 'minutestotime'
      },
      {
        label: 'report.view.productiveHours',
        identifier: 'absentHours',
        width: '25%',
        sort: true,
        type: 'minutestotime'
      },
      {
        label: 'report.view.productivity',
        identifier: 'ratio',
        width: '20%',
        sort: true,
        type: 'progress',
        warning: true
      }
    ]

    return (
      <div className='listwrap'>
        <List
          objectList={projectList}
          columns={columns}
          renderCustomCell={this._onRenderCustom.bind(this)}
          sortOptions={sortOptions}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
        {this._renderExportDialog(this, this.props.reportIdent)}
      </div>
    )
  }

  _renderEmployeeProductivityListV2 () {
    if (this.data.reportInfo.items.length <= 0) {
      return null
    }
    const projectList = this.data.reportInfo.items
    const sortOptions = [
      { label: 'Name', value: 'name' },
      { label: 'Gross available hours', value: 'grossHours' },
      { label: 'Net available hours', value: 'netHours' },
      { label: 'Planned hours', value: 'plannedHours' },
      { label: 'Tracked hours', value: 'trackedHours' },
      { label: 'Ratio productive hours / available hours', value: 'ratio' }
    ]
    const bIsPlannerAllowed = Acl.isPlannerAllowed()
    const columns = [
      {
        label: 'report.view.name',
        identifier: 'name',
        width: '18%',
        sort: true,
        type: 'text'
      },
      {
        label: 'report.view.grossAvailableHours',
        identifier: 'grossHours',
        width: '16%',
        sort: false,
        type: 'minutestotime'
      },
      {
        label: 'report.view.netAvailableHours',
        identifier: 'netHours',
        width: '15%',
        sort: false,
        type: 'minutestotime'
      }
    ]

    if (bIsPlannerAllowed) {
      columns.push({
        label: 'report.view.plannedHours',
        identifier: 'plannedHours',
        width: '12%',
        sort: false,
        type: 'minutestotime'
      })
    }

    columns.push(
      {
        label: 'report.view.allHours',
        identifier: 'trackedHours',
        width: bIsPlannerAllowed ? '12%' : '14%',
        sort: false,
        type: 'minutestotime'
      },
      {
        label: 'report.view.trackedHours',
        identifier: 'productivityHours',
        width: bIsPlannerAllowed ? '12%' : '14%',
        sort: false,
        type: 'minutestotime'
      },
      {
        label: 'report.view.ratioHours',
        identifier: 'ratio',
        width: '15%',
        sort: false,
        type: 'progress',
        warning: true
      }
    )

    return (
      <div className='listwrap'>
        <List
          objectList={projectList}
          columns={columns}
          renderCustomCell={this._onRenderCustom.bind(this)}
          sortOptions={sortOptions}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
        {this._renderExportDialog(this, this.props.reportIdent)}
      </div>
    )
  }

  _renderTimeRegistrationList () {
    if (this.data.reportInfo.items.length <= 0) {
      return null
    }

    const projectList = this.data.reportInfo.items
    const sortOptions = [
      { label: 'Date', value: 'createdOn' },
      { label: 'Activity', value: 'activity' },
      { label: 'Description', value: 'description' },
      { label: 'Medewerker', value: 'firstName' },
      { label: 'Time', value: 'timeTaken' },
      { label: 'Rate', value: 'commercialRate' },
      { label: 'Total', value: 'total' }
    ]
    const columns = [
      {
        label: 'report.view.date',
        identifier: 'createdOn',
        width: '9%',
        sort: true,
        type: 'date'
      },
      {
        label: 'report.view.projectName',
        identifier: 'project',
        width: '21%',
        sort: true,
        type: 'custom',
        customType: 'descWithTooltip'
      },
      {
        label: 'report.view.phase',
        identifier: 'phase',
        width: '20%',
        sort: true,
        type: 'custom',
        customType: 'descWithTooltip'
      },
      {
        label: 'report.view.activity',
        identifier: 'activity',
        width: '10%',
        type: 'custom',
        customType: 'descWithTooltip'
      },
      {
        label: 'report.view.description',
        identifier: 'description',
        width: '10%',
        sort: true,
        type: 'custom',
        customType: 'descWithTooltip'
      },
      {
        label: 'report.view.medewerker',
        identifier: 'userName',
        width: '10%',
        sort: true,
        type: 'text',
        field: 'text'
      },
      {
        label: 'report.view.time',
        identifier: 'timeTaken',
        width: '5%',
        sort: true,
        type: 'minutestotime'
      },
      {
        label: 'report.view.rate',
        identifier: 'appliedRate',
        width: '5%',
        sort: true,
        type: 'text'
      },
      {
        label: 'report.view.total',
        identifier: 'total',
        width: '10%',
        sort: true,
        type: 'custom',
        customType: 'price'
      }
    ]

    let totalTimeTaken = 0
    let total = 0

    this.data.reportInfo.items.map(item => {
      totalTimeTaken += item.timeTaken
      total += item.total
    })

    const footerObject = {
      createdOn: null,
      activity: '',
      description: '',
      userName: <IntlMessage ident='report.view.total' />,
      timeTaken: totalTimeTaken,
      appliedRate: '',
      total: total
    }

    return (
      <div className='listwrap'>
        <DataTable
          objectList={projectList}
          footerObject={footerObject}
          columns={columns}
          renderCustomCell={this._onRenderCustom.bind(this)}
          onRenderFooter={this._onRenderFooter.bind(this)}
          sortOptions={sortOptions}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
        />
        {this._renderExportDialog(this, this.props.reportIdent)}
      </div>
    )
  }

  _renderPlannerOverview () {
    if (this.data.reportInfo.items.length <= 0) {
      return null
    }

    return (
      <PlannerContent
        items={this._getRenderObjectPlanner()}
        filter={this.data.pageState.filter.plannerOverview}
      />
    )
  }

  _onListItemClick (project) {
    if (project && project.id) {
      app.changePage('projectview-overview', project.id)
    }
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _onRenderFooter (report, column, idx) {
    const value = report[column.identifier]
    const width = column.width

    if (column.customType === 'price') {
      return (
        <ReportPriceCell
          price={value}
          width={width}
          key={idx}
          tooltip={null}
          tooltipData={null}
          formatOverdue={column.formatOverdue || false}
          formatMargin={column.formatMargin || false}
        />
      )
    } else if (column.customType === 'descWithTooltip') {
      const info = {
        value: value
      }

      return (
        <ReportTimeDescCell
          key={idx}
          info={info}
          width={width}
          tooltip={null}
          defaultValue='&nbsp;'
        />
      )
    }

    return ''
  }

  _onRenderCustom (report, column, idx) {
    const value = report[column.identifier]
    const width = column.width
    const projectSetting = app.projectSetting

    if (column.customType === 'price') {
      const tooltipInfo = column.getTooltipInfo
        ? column.getTooltipInfo(report)
        : null
      return (
        <ReportPriceCell
          price={value}
          width={width}
          key={idx}
          tooltip={tooltipInfo ? tooltipInfo.ident : ''}
          tooltipData={tooltipInfo ? tooltipInfo.data : {}}
          formatOverdue={column.formatOverdue || false}
          formatMargin={column.formatMargin || false}
          baseTotal={column.baseTotalField ? report[column.baseTotalField] : 0}
        />
      )
    } else if (column.customType === 'textWithInfo') {
      const title = report[column.identifier]
      const status = report[column.info1Identifier]
        ? report[column.info1Identifier]
        : ''
      const info =
        column.info3Identifier && report[column.info3Identifier]
          ? report[column.info3Identifier]
          : ''

      let contact = ''
      if (column.field && report[column.field]) {
        contact = report[column.field][column.info2Identifier]
      }

      return (
        <ReportInfoCell
          title={title}
          status={status}
          info={info}
          contact={contact}
          width={width}
          key={idx}
          onView={this._onListItemClick.bind(this, report)}
        />
      )
    } else if (column.customType === 'progresswithinfo') {
      const info = {
        value: report[column.value],
        totalValue: report[column.totalValue],
        status: column.identifier
      }

      return <ReportProjectProgressCell key={idx} report={info} width={width} />
    } else if (column.customType === 'descWithTooltip') {
      const info = {
        value: value
      }

      return (
        <ReportTimeDescCell
          key={idx}
          info={info}
          width={width}
          tooltip={value}
          tooltipPosition='bottom'
          onView={this._onListItemClick.bind(this, report)}
        />
      )
    } else if (column.customType === 'projectwithinfo') {
      const info = {
        title: report.title,
        projectSubtitle: projectSetting.useProjectNo
          ? report.projectNumber
          : '',
        subTitle: report[column.subTitle]
          ? report[column.subTitle].company
          : '',
        projectManagerName: report.projectManagerName,
        values: [
          { label: 'report.view.labelBudget', value: report.budgetHours },
          { label: 'report.view.labelPlanned', value: report.valuePlannedHours },
          { label: 'report.view.labelTracked', value: report.trackedHours }
        ]
      }

      return (
        <ReportProjectTitleCell
          key={idx}
          info={info}
          width={width}
          onView={this._onListItemClick.bind(this, report)}
        />
      )
    } else if (column.customType === 'projectManager') {
      const info = {
        name: report.projectManagerName
      }

      return (
        <ReportProjectManagerCell
          key={idx}
          info={info}
          onView={this._onListItemClick.bind(this, report)}
          width={width}
        />
      )
    }

    return ''
  }

  _getRenderObjectPlanner () {
    const oldPlannerData = this.data.oldPlannerData

    let plannerItems = []
    if (this.data.reportInfo && this.data.reportInfo.items) {
      plannerItems = this.data.reportInfo.items.map(contact => {
        const oldContactObj = _.find(oldPlannerData, oldContact => {
          if (oldContact.id === contact.id) {
            return oldContact.expanded === true
          }
        })

        contact.title = contact.company
        contact.expanded = oldContactObj ? oldContactObj.expanded : false

        contact.projects.map(project => {
          let oldProjectObj = null
          if (oldContactObj) {
            oldProjectObj = _.find(oldContactObj.projects, oldProject => {
              if (oldProject.id === project.id) {
                return oldProject.expanded === true
              }
            })
          }

          project.expanded = oldProjectObj ? oldProjectObj.expanded : false

          project.phases = []
          if (project.budget && project.budget.phases) {
            project.budget.phases.map((phase, idx) => {
              let oldPhaseObj = null
              if (oldProjectObj) {
                oldPhaseObj = _.find(
                  oldProjectObj.phases,
                  (oldPhase, oldIdx) => {
                    if (oldIdx === idx) {
                      return oldPhase.expanded === true
                    }
                  }
                )
              }

              phase.expanded = oldPhaseObj ? oldPhaseObj.expanded : false

              phase.activities.map((activity, idx) => {
                let oldActivityObj = null
                if (oldPhaseObj) {
                  oldActivityObj = _.find(
                    oldPhaseObj.activities,
                    (oldActivity, oldIdx) => {
                      if (idx === oldIdx) {
                        return oldActivity.expanded === true
                      }
                    }
                  )
                }

                activity.expanded = oldActivityObj
                  ? oldActivityObj.expanded
                  : false
              })
            })

            project.phases = _.cloneDeep(project.budget.phases)
            delete project.budget.phases
          }
        })

        return contact
      })
    }

    return plannerItems
  }

  _getPlannerFilter (filter) {
    filter = filter || {}
    const filterType = filter ? filter.filterType : 'half-year'
    const year = filter ? filter.year : DateUtil.getLocalYear()
    const startMonth = filter ? filter.startMonth : 0
    const startWeekNo = filter ? filter.startWeekNo : 1

    let fromDate = new Date(year, startMonth, 1)
    let toDate = new Date(year, startMonth + 6, 0) // 6 months
    toDate.setHours(23, 59, 59, 0)
    if (filterType !== 'half-year') {
      fromDate = this._getMondayByWeek(year, startWeekNo)
      toDate = DateUtil.addDaysToDate(fromDate, 7 * 4 + 6) // 4 weeks
    }

    filter.filterType = filterType
    filter.fromDate = fromDate
    filter.toDate = toDate

    return filter
  }

  _getMondayByWeek (year, weekNo) {
    const date = new Date(year, 0, 1 + (weekNo - 1) * 7)
    const day = date.getDay()
    if (day === 1) {
      // If monday
      return date
    }

    const currDate = date.getDate()

    let diff = currDate
    if (day >= 4) {
      diff = currDate - day + (day === 0 ? -6 : 1)
    } else {
      diff = currDate + (1 - day)
    }

    return new Date(date.setDate(diff))
  }

  _getEmpProductivityFilter (filter) {
    filter = filter || {}

    if (!filter.filterType || !filter.graphFromDate || !filter.graphToDate) {
      filter.filterType = 'month'

      const currDate = new Date()
      const fromDate = new Date(currDate.getFullYear(), currDate.getMonth(), 1)
      const toDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth() + 1,
        0,
        23,
        59,
        59
      )

      filter.graphFromDate = fromDate
      filter.graphToDate = toDate
    }

    if (!filter.fromDate || !filter.toDate) {
      const currDate = new Date()
      const fromDate = new Date(currDate.getFullYear(), currDate.getMonth(), 1)
      const toDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth() + 1,
        0,
        23,
        59,
        59
      )

      filter.fromDate = fromDate
      filter.toDate = toDate
    }

    filter.fromDate = new Date(filter.fromDate)
    filter.toDate = new Date(filter.toDate)
    filter.graphFromDate = new Date(filter.graphFromDate)
    filter.graphToDate = new Date(filter.graphToDate)

    return filter
  }

  _getDefaultDateFilter () {
    const reportIdent = this.props.reportIdent
    const dateFilter = {
      ident: 'custom',
      value: null
    }
    const date = DateUtil.getUTCCurrentDate()
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const currDay = date.getDate()
    /* const lastMonthFilter = {
      from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
      to: DateUtil.getUTCDate(currYear, currMonth, 0)
    }; */

    const thisMonthFilter = {
      from: DateUtil.getUTCDate(currYear, currMonth, 1),
      to: DateUtil.getUTCDate(currYear, currMonth + 1, 0)
    }

    if (
      reportIdent === REPORTS.EMPLOYEE_PRODUCTIVITY_V2 ||
      reportIdent === REPORTS.PLANNER_OVERVIEW
    ) {
      dateFilter.value = thisMonthFilter
    } else if (
      _.findIndex(
        [
          REPORTS.CLOSED_PROJECTS,
          REPORTS.EMPLOYEE_PRODUCTIVITY,
          REPORTS.TIME_REGISTRATION,
          REPORTS.CLOSED_PROJECTS_V2
        ],
        ident => ident === reportIdent
      ) >= 0
    ) {
      // This month
      dateFilter.value = thisMonthFilter
    } else {
      // Work in progress
      // Today
      dateFilter.value = DateUtil.getUTCDate(currYear, currMonth, currDay)
    }

    return dateFilter
  }

  /* Work In Progress Header Functions - START */
  _renderHeaderWorkInProgress () {
    const { pageState } = this.data
    const date = DateUtil.getUTCCurrentDate()
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const currDay = date.getDate()
    const filter =
      pageState.filter && pageState.filter.workInProgress
        ? pageState.filter.workInProgress
        : {}
    const actions = [
      {
        ident: 'export',
        icon: 'download-solid',
        tooltip: 'report.view.tipDownloadReport',
        tooltipPosition: 'bottom',
        onClick: this._onExport.bind(this)
      }
    ]

    const filters = [
      {
        type: 'label',
        label: 'report.view.headerTitleWorkInProgress'
      },
      {
        ident: 'dateFilter',
        type: 'date',
        label: 'report.view.filterToday',
        isMulti: false,
        value: filter.dateFilter || null,
        dateOptions: [
          {
            ident: 'today',
            label: 'report.view.filterToday',
            value: DateUtil.getUTCDate(currYear, currMonth, currDay)
          },
          {
            ident: 'yesterday',
            label: 'report.view.filterYesterday',
            value: DateUtil.getUTCDate(currYear, currMonth, currDay - 1)
          },
          {
            ident: 'end-of-lastmonth',
            label: 'report.view.filterEndOfLastMonth',
            value: DateUtil.getUTCDate(currYear, currMonth, 0)
          }
        ],
        defaultValue: {
          ident: 'today',
          label: 'report.view.filterToday',
          value: DateUtil.getUTCDate(currYear, currMonth, currDay)
        }
      },
      {
        type: 'label',
        label: 'report.view.for'
      },
      {
        ident: 'contact',
        type: 'tag',
        label: 'report.view.filterAllClients',
        placeholder: 'report.view.searchClientPlaceholder',
        isMulti: false,
        value: filter.contact || null
      },
      {
        type: 'label',
        label: 'report.view.taggedWith'
      },
      {
        ident: 'tags',
        type: 'tag',
        label: 'report.view.filterAllTags',
        placeholder: 'report.view.searchTagPlaceholder',
        isMulti: true,
        value: filter.tags || []
      }
    ]

    const filterActions = [
      {
        ident: 'export',
        icon: 'download',
        tooltip: 'report.view.tipDownloadReport',
        tooltipPosition: 'bottom',
        className: 'filterdownload',
        type: 'invert',
        onClick: this._onExport.bind(this)
      }
    ]

    return (
      <PageHeader
        ref={this._references.reportHeader}
        title='report.list.titleWorkInProgress'
        icon={<ReportsIcon width={25} />}
        hasFilter
        filters={filters}
        filterActions={filterActions}
        actions={actions}
        onChange={this._onHeaderChangeFilterWorkInProgress.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
      />
    )
  }

  _onHeaderChangeFilterWorkInProgress (filter) {
    if (!this.data.pageState.filter) {
      this.data.pageState.filter = {}
    }

    this.data.pageState.filter.workInProgress = filter
    this.data.pageNo = 1

    this._reloadData()
  }
  /* Work In Progress Header Functions - END */

  /* Time Registration Header Functions - START */
  _renderHeaderTimeRegistration () {
    const { pageState } = this.data
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
    lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)
    const lastWeekEndDate = new Date(lastWeekStartDate)
    lastWeekEndDate.setDate(lastWeekStartDate.getDate() + 6)
    const filter =
      pageState.filter && pageState.filter.timeRegistration
        ? pageState.filter.timeRegistration
        : {}
    const actions = [
      {
        ident: 'export',
        icon: 'download-solid',
        tooltip: 'report.view.tipDownloadReport',
        tooltipPosition: 'bottom',
        onClick: this._onExport.bind(this)
      }
    ]

    const filters = [
      {
        type: 'label',
        label: 'report.view.headerTitleTimeRegistration'
      },
      {
        ident: 'user',
        type: 'tag',
        label: 'report.view.filterAllTeamMembers',
        placeholder: 'report.view.searchUserPlaceholder',
        isMulti: false,
        value: filter.user || null
      },
      {
        type: 'label',
        label: 'report.view.for'
      },
      {
        ident: 'project',
        type: 'tag',
        label: 'report.view.filterAllProjects',
        placeholder: 'report.view.searchProjectPlaceholder',
        isMulti: false,
        value: filter.project || null
      },
      {
        type: 'label',
        label: 'report.view.for'
      },
      {
        ident: 'dateFilter',
        type: 'date',
        label: 'report.view.filterThisMonth',
        isMulti: true,
        value: filter.dateFilter || null,
        dateOptions: [
          {
            ident: 'last-week',
            label: 'report.view.filterLastWeek',
            value: {
              from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
              to: DateUtil.getUTCDateFromTime(lastWeekEndDate)
            }
          },
          {
            ident: 'last-month',
            label: 'report.view.filterLastMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
              to: DateUtil.getUTCDate(currYear, currMonth, 0)
            }
          },
          {
            ident: 'last-year',
            label: 'report.view.filterLastYear',
            value: {
              from: DateUtil.getUTCDate(currYear - 1, 0, 1),
              to: DateUtil.getUTCDate(currYear - 1, 11, 31)
            }
          },
          {
            ident: 'this-month',
            label: 'report.view.filterThisMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth, 1),
              to: DateUtil.getUTCDate(currYear, currMonth + 1, 0)
            }
          },
          {
            ident: 'this-year',
            label: 'report.view.filterThisYear',
            value: {
              from: DateUtil.getUTCDate(currYear, 0, 1),
              to: DateUtil.getUTCDate(currYear, 11, 31)
            }
          }
        ],
        defaultValue: {
          ident: 'this-month',
          label: 'report.view.filterThisMonth',
          value: {
            from: DateUtil.getUTCDate(currYear, currMonth, 1),
            to: DateUtil.getUTCDate(currYear, currMonth + 1, 0)
          }
        }
      },
      {
        type: 'label',
        label: 'report.view.filterOf'
      },
      {
        ident: 'contact',
        type: 'tag',
        label: 'report.view.filterAllClients',
        placeholder: 'report.view.searchClientPlaceholder',
        isMulti: false,
        value: filter.contact || null
      },
      {
        type: 'label',
        label: 'report.view.taggedWith'
      },
      {
        ident: 'tags',
        type: 'tag',
        label: 'report.view.filterAllTags',
        placeholder: 'report.view.searchTagPlaceholder',
        isMulti: true,
        value: filter.tags || []
      }
    ]

    const filterActions = [
      {
        ident: 'export',
        icon: 'download',
        tooltip: 'report.view.tipDownloadReport',
        tooltipPosition: 'bottom',
        className: 'filterdownload',
        type: 'invert',
        onClick: this._onExport.bind(this)
      }
    ]

    return (
      <PageHeader
        ref={this._references.reportHeader}
        title='report.list.titleTimeRegistration'
        icon={<ReportsIcon width={25} />}
        hasFilter
        filters={filters}
        filterActions={filterActions}
        actions={actions}
        onChange={this._onHeaderChangeFilterTimeRegistration.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
      />
    )
  }

  _onHeaderChangeFilterTimeRegistration (filter) {
    if (!this.data.pageState.filter) {
      this.data.pageState.filter = {}
    }

    this.data.pageState.filter.timeRegistration = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'contact') {
      this._onCommonFilterContactSearch(keyword, callback)
    } else if (filterIdent === 'tags') {
      const { pageState } = this.data
      const filter =
        pageState.filter && pageState.filter.timeRegistration
          ? pageState.filter.timeRegistration
          : {}
      const excludeTags = []

      if (filter && filter.tags) {
        filter.tags.forEach(tag => {
          if (tag) {
            excludeTags.push(tag.value)
          }
        })
      }

      this._onCommonFilterTagSearch(keyword, excludeTags, callback)
    } else if (filterIdent === 'user') {
      this._onSearchUser(keyword, callback)
    } else if (filterIdent === 'project') {
      this._onCommonFilterProjectSearch(keyword, false, callback)
    }
  }
  /* Time Registration Header Functions - END */
}

export default PageReportView
